import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InvertButton } from 'component-library';
import moment from 'moment';
import { comparisonColor, comparisonPositive } from '../../helpers/Custom';
import { CustomerSystemCount, Dashboard } from '../../models/ApiModels';
import { GetCustomerSystemCounts } from '../../services/DashboardService';
import Modal from '../../utils/Modal';
import useRequest from '../../utils/net/useRequest';

interface Props {
  dashboardData: Dashboard;
  compare: boolean;
  startDate: { date: string; value: string };
  endDate: { date: string; value: string };
  openSystemPerCustomerModal: boolean;
  setOpenSystemPerCustomerModal: (open: boolean) => void;
}

const getHeadingClass = (index: number) => {
  switch (index) {
    case 0:
      return 'prose-heading4 text-ultimate-orange-100';
    case 1:
      return 'prose-heading4';
    case 2:
      return 'prose-heading4';
    default:
      return 'prose-paragraph-base';
  }
};

const DashboardDataCustomers = (props: Props) => {
  return (
    <div className='flex-1 flex flex-col w-full'>
      <div className='prose-heading4 mb-5 mt-10'>Customers</div>
      <div className='bg-gray-3 py-4 px-8 mb-4 md:mb-0 flex-1 flex flex-col'>
        <div className='text-center mt-4 mb-6'>Amount of systems per customer</div>
        {props.dashboardData && (
          <ul>
            {props.dashboardData.customerSystemCounts.customerSystemCount.map((count, index) => (
              <li key={count.key} className='flex justify-between items-center'>
                <span className={`${getHeadingClass(index)}`}>{count.key}</span>
                <div className='flex gap-2'>
                  <span className='min-w-[2rem] text-right'>{count.count}</span>
                  {props.compare && (
                    <span className={`min-w-[2rem]  ${comparisonColor(count.diff)}`}>
                      {comparisonPositive(count.diff) + count.diff}
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
        <div
          className='text-right mt-auto ml-auto cursor-pointer'
          onClick={() => {
            props.setOpenSystemPerCustomerModal(true);
          }}
        >
          <span className='pr-2'>View all</span>
          <FontAwesomeIcon icon={faArrowRight} />
        </div>

        {props.openSystemPerCustomerModal && (
          <DashboardDataCustomersModal
            dashboardData={props.dashboardData}
            compare={props.compare}
            startDate={props.startDate}
            endDate={props.endDate}
            openSystemPerCustomerModal={props.openSystemPerCustomerModal}
            setOpenSystemPerCustomerModal={props.setOpenSystemPerCustomerModal}
          />
        )}
      </div>
    </div>
  );
};

export default DashboardDataCustomers;

const DashboardDataCustomersModal = (props: Props) => {
  const [dashboardCustomerSystemCount, isDashboardCustomerSystemCountLoading] = useRequest<CustomerSystemCount>(
    () =>
      GetCustomerSystemCounts(
        moment(props.startDate.date).format('YYYY-MM-DD'),
        moment(props.endDate.date).format('YYYY-MM-DD')
      ),
    [props.startDate, props.endDate, props.compare]
  );

  return (
    <Modal>
      {dashboardCustomerSystemCount && (
        <>
          <div>Full Amount of system per customer</div>
          <ul>
            {dashboardCustomerSystemCount.customerSystemCount.map((count, index) => (
              <li key={count.key} className='flex justify-between items-center'>
                <span className={`${getHeadingClass(index)}`}>{count.key}</span>
                <div className='flex gap-2'>
                  <span className='min-w-[2rem] text-right'>{count.count}</span>
                  {props.compare && (
                    <span className={`min-w-[2rem]  ${comparisonColor(count.diff)}`}>
                      {comparisonPositive(count.diff) + count.diff}
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
          <InvertButton label='Close' onClick={() => props.setOpenSystemPerCustomerModal(false)} />
        </>
      )}
    </Modal>
  );
};
